import { useEffect, useState } from "react";
import { useSeasonConfig } from "./useSeasonConfig";
import { useLeague } from "../context/LeagueContext";
import { getBiddingWindow } from "../utils/season";

// Where bidding stands right now, for the Teams tab, the team drawer, the bid
// sheet and the lineup chips, so they cannot disagree about whether a bid can
// be placed. See getBiddingWindow in season.js for the rule and place_bid
// (migration 067) for the gate that actually holds.
//
// The window is a clock rule, so the state is recomputed each minute: a tab
// left open over 10am Sunday opens without a reload.
//
// Test leagues ignore the clock (migration 068). Optional chaining on the
// league: the team drawer also opens from Home, outside any league route,
// where there is no LeagueContext.
export function useBiddingWindow() {
  const { config: seasonConfig } = useSeasonConfig();
  const isTestLeague = Boolean(useLeague()?.leagueData?.is_test);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return getBiddingWindow({ seasonConfig, now, isTestLeague });
}
